import { dataPersistence } from './dataPersistence'

export const demoReset = {
  resetUser: async (userId: string) => {
    try {
      sessionStorage.removeItem('sales_hub_shown_demo1_session')
      localStorage.removeItem('sales_hub_shown_demo1_session')
      const keysToRemove: string[] = []
      
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && (
          key.startsWith('exchange_wizard_') ||
          key.startsWith('sale_wizard_') ||
          key.startsWith('user_data_cache') ||
          key.startsWith('wizard_state_') ||
          key.startsWith('document_') ||
          key.startsWith('esign_') ||
          key.startsWith('exchange_agreement') ||
          key.startsWith('user_saved_signature') ||
          key.startsWith('exchange_docs_') ||
          key.startsWith('user_activities') ||
          key.startsWith('property_sale_date') ||
          key.startsWith('calculator_savings') ||
          key.startsWith('demo_activities_logged') ||
          key.startsWith('sales_hub_submitted') ||
          key.startsWith('identification_hub_submitted') ||
          key.startsWith('purchase_hub_submitted') ||
          key.startsWith('disbursement_hub_submitted') ||
          key.startsWith('acquisition_hub_submitted') ||
          key.startsWith('hub_locked_') ||
          key.startsWith('w9_') ||
          key.startsWith('kyc_modal_shown_') ||
          key.startsWith('sales_hub_phase1_step_') ||
          key.includes('_initial') ||
          key.includes('_phase1') ||
          key.includes('_exchange') ||
          key.includes('_acquisition') ||
          key.includes('_signed') ||
          key.includes('_signature')
        )) {
          keysToRemove.push(key)
        }
      }
      
      keysToRemove.forEach(key => localStorage.removeItem(key))
      
      // Clear dataPersistence cache which may contain Phase 1 property data
      dataPersistence.clear()
      
      // Also clear demo unlock flags to relock hubs
      localStorage.removeItem('demo_unlock_all')
      localStorage.removeItem('demo_identity_verified')
      
      // Clear all hub lock states (explicitly in case pattern didn't catch them)
      localStorage.removeItem('hub_locked_sales')
      localStorage.removeItem('hub_locked_identification')
      localStorage.removeItem('hub_locked_purchase')
      localStorage.removeItem('hub_locked_disbursement')
      localStorage.removeItem('hub_locked_irs')
      
      // Explicitly clear all hub submission dates to reset Phase 1 timeline
      localStorage.removeItem('sales_hub_submitted_date')
      localStorage.removeItem('identification_hub_submitted_date')
      localStorage.removeItem('purchase_hub_submitted_date')
      localStorage.removeItem('disbursement_hub_submitted_date')
      localStorage.removeItem('acquisition_hub_submitted_date')
      
      // Explicitly clear signed document flags to ensure Phase 1 shows as not started
      localStorage.removeItem('exchange_agreement_signed')
      localStorage.removeItem('exchange_agreement_data')
      localStorage.removeItem('exchange_agreement_signed_date')
      localStorage.removeItem('exchange_agreement_signed_by')
      localStorage.removeItem('w9_signed')
      localStorage.removeItem('w9_signature')
      localStorage.removeItem('w9_signed_date')
      localStorage.removeItem('w9_signed_by')
      localStorage.removeItem('sales_hub_submitted')
      
      // Set flag to prevent auto-opening sales hub after reset
      // User should go through verify identity flow first
      localStorage.setItem('demo_reset_just_completed', 'true')
      
      // Also clear auth token and current exchange for full reset
      localStorage.removeItem('auth_token')
      localStorage.removeItem('current_exchange_id')
      
      return { success: true, cleared: keysToRemove.length }
    } catch (error) {
      console.error('Demo reset failed:', error)
      throw error
    }
  },

  resetAll: () => {
    try {
      sessionStorage.removeItem('sales_hub_shown_demo1_session')
      localStorage.removeItem('sales_hub_shown_demo1_session')
      const keysToRemove: string[] = []
      
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && (
          key.startsWith('exchange_wizard_') ||
          key.startsWith('sale_wizard_') ||
          key.startsWith('user_data_cache') ||
          key.startsWith('wizard_state_') ||
          key.startsWith('document_') ||
          key.startsWith('esign_') ||
          key.startsWith('exchange_agreement') ||
          key.startsWith('user_saved_signature') ||
          key.startsWith('exchange_docs_') ||
          key.startsWith('user_activities') ||
          key.startsWith('property_sale_date') ||
          key.startsWith('calculator_savings') ||
          key.startsWith('demo_activities_logged') ||
          key.startsWith('sales_hub_submitted') ||
          key.startsWith('identification_hub_submitted') ||
          key.startsWith('purchase_hub_submitted') ||
          key.startsWith('disbursement_hub_submitted') ||
          key.startsWith('acquisition_hub_submitted') ||
          key.startsWith('hub_locked_') ||
          key.startsWith('w9_') ||
          key.startsWith('kyc_modal_shown_') ||
          key.startsWith('sales_hub_phase1_step_') ||
          key.includes('_initial') ||
          key.includes('_phase1') ||
          key.includes('_exchange') ||
          key.includes('_acquisition') ||
          key.includes('_signed') ||
          key.includes('_signature')
        )) {
          keysToRemove.push(key)
        }
      }
      
      keysToRemove.forEach(key => localStorage.removeItem(key))
      
      // Clear dataPersistence cache which may contain Phase 1 property data
      dataPersistence.clear()
      
      // Also clear demo unlock flags to relock hubs
      localStorage.removeItem('demo_unlock_all')
      localStorage.removeItem('demo_identity_verified')
      
      // Clear all hub lock states (explicitly in case pattern didn't catch them)
      localStorage.removeItem('hub_locked_sales')
      localStorage.removeItem('hub_locked_identification')
      localStorage.removeItem('hub_locked_purchase')
      localStorage.removeItem('hub_locked_disbursement')
      localStorage.removeItem('hub_locked_irs')
      
      // Explicitly clear all hub submission dates to reset Phase 1 timeline
      localStorage.removeItem('sales_hub_submitted_date')
      localStorage.removeItem('identification_hub_submitted_date')
      localStorage.removeItem('purchase_hub_submitted_date')
      localStorage.removeItem('disbursement_hub_submitted_date')
      localStorage.removeItem('acquisition_hub_submitted_date')
      
      // Explicitly clear signed document flags to ensure Phase 1 shows as not started
      localStorage.removeItem('exchange_agreement_signed')
      localStorage.removeItem('exchange_agreement_data')
      localStorage.removeItem('exchange_agreement_signed_date')
      localStorage.removeItem('exchange_agreement_signed_by')
      localStorage.removeItem('w9_signed')
      localStorage.removeItem('w9_signature')
      localStorage.removeItem('w9_signed_date')
      localStorage.removeItem('w9_signed_by')
      localStorage.removeItem('sales_hub_submitted')
      
      // Set flag to prevent auto-opening sales hub after reset
      // User should go through verify identity flow first
      localStorage.setItem('demo_reset_just_completed', 'true')
      
      // Also clear auth token and current exchange for full reset
      localStorage.removeItem('auth_token')
      localStorage.removeItem('current_exchange_id')
      
      return { success: true, cleared: keysToRemove.length }
    } catch (error) {
      console.error('Demo reset failed:', error)
      throw error
    }
  }
}

